import React from 'react'
import { Helmet } from 'react-helmet'

import { Header } from 'src/components/common/TitleSection'
import { ServicesLabels } from 'src/constants'
import { MapServices } from './mapServices'
import { ContentSection } from './styles'
import services from 'src/assets/Services/ImageToStl.com_headerbg.avif'
import { useTranslations } from 'src/provider/LocaleProvider'
export function Services() {
    const t = useTranslations()
    const { ContentOltServices } = ServicesLabels()
    return (
        <>
            <Helmet>
                <title>{t('services.helmet.title') ?? ''}</title>
                <meta
                    name="description"
                    content={t('services.helmet.description') ?? ''}
                />
            </Helmet>

            <Header
                title={t('services.header.title')}
                subTitle={t('services.header.content')}
                image={services}
            />
            <ContentSection>
                {ContentOltServices.map((ServicesData) => {
                    return (
                        <MapServices key={ServicesData.id} {...ServicesData} />
                    )
                })}
            </ContentSection>
        </>
    )
}
